module.exports = "/static/assets/ddfe82a80c9428360c45490fd749a70f.svg";